// Constants
export const list_otros = () => {
    return {
        list_otros: {
            id: {
                namepath: ['facturacion_egreso'],
                type: "number",
                label: "id",
                placeholder: "",
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: true,
                    predeterminate: "",
                }
            },
            name: {
                type: "text",
                label: "Nombre o Razon Social",
                placeholder: "",
                namepath: ['facturacion_egreso'],
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: "",
                }
            },
            documento: {
                type: "number",
                label: "Documento",
                placeholder: "",
                namepath: ['facturacion_egreso'],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                    prepend: '',
                    append: '',
                }
            },
            direccion: {
                type: "text",
                label: "Direccion",
                placeholder: "",
                namepath: ['facturacion_egreso'],
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: "",
                }
            },
            telefonos: {
                type: "text",
                label: "Telefonos",
                placeholder: "",
                namepath: ['facturacion_egreso'],
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: "",
                }
            },
        }
    }
}